'use strict';

console.log('i am loaded');